import React, { useEffect, useState } from "react";
import { HiOutlineClock } from "react-icons/hi";
import { post } from "../../api";
import { CLEAR_BASKET_URL } from "../../api/apiRoutes";
import { setSuccessMessage } from "../../store/alerts/alertsActions";
import useFacility from "../../../utils/hooks/useFacility";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

// const Timer = () => {
//   const timeToBuy = useSelector((state: State) => state.config.configuration.timeToFinishTransaction);
// import { useDispatch } from "react-redux";

// const Timer = () => {

const Timer = ({ delayResend = "900" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const timeToBuy = useSelector((state: State) => state.config.configuration.timeToFinishTransaction);
  const dispatch = useDispatch();
  const homePage = sessionStorage.getItem("HomePage")
  const handleClearBasket = async () => {
    const { isError } = await post(CLEAR_BASKET_URL(facilityIds));
    if (!isError) {
      // dispatch(updateSelectedSeats([]));
      dispatch(setSuccessMessage(t("wyczyszczono_koszyk")));
      setTimeout(() => {
        if(homePage){
          navigate(homePage);
        }
      
      }, 500);
    }
  };
  const facilityIds = useFacility();
  const [time, setTime] = useState(timeToBuy * 60 || "900");
  const [delay, setDelay] = useState(+time);
  const minutes = Math.floor(delay / 60);
  const seconds = Math.floor(delay % 60);

  useEffect(() => {
    const timer = setInterval(() => {
      setDelay(delay - 1);
    }, 1000);

    if (delay === 0) {
      clearInterval(timer);
      handleClearBasket();
    }

    return () => {
      clearInterval(timer);
    };
  });

  return (
    <div className="timer-basket flex-center-center">
      <HiOutlineClock className="ticket-line-icon" />
      <span>{t("czas_na_dokonczenie_zakupu")}:</span>
      <b>
        {minutes}m:{seconds}s
      </b>
    </div>
  );
};

export default Timer;
